const HealthCheck = () => {
  const healthData = {
    status: 'ok',
    timestamp: new Date().toISOString(),
    version: '1.0.0',
    service: 'customer-portal',
    port: 3002,
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'monospace' }}>
      <h2>Health Check</h2>
      <pre
        style={{ background: '#f5f5f5', padding: '15px', borderRadius: '4px' }}
      >
        {JSON.stringify(healthData, null, 2)}
      </pre>
    </div>
  );
};

export default HealthCheck;
